import apiClient from "QueryClient/axiosClient";

export const fetchRequiredPolicies = () => {
  return apiClient.get("/policies/required");
};

export const fetchLatestAcceptance = (policyKey) => {
  return apiClient.get("/policies/acceptance/latest", {
    params: { policyKey },
  });
};

export const acceptPolicy = (payload) => {
  return apiClient.post("/policies/accept", payload);
};
